export enum FilterType
{
    None = "None",
    Update = "Update",
    Install = "Install",
    Delete = "Delete",
}